module.exports = __webpack_public_path__ + "f5d0c0ecf2f4853e36ba98155cc9e762.pdf";